import { AccordionDetails, Stepper } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const StyledExpansionPanelDetails = styled(AccordionDetails)(() => ({
  padding: '0 16px 16px',
}));

const TransactionHistoryBase = ({ children, manualAdjustment }) => (
  <StyledExpansionPanelDetails>
    <Stepper
      orientation="vertical"
      sx={{ padding: 0, width: "100%" }}
      connector={null}
    >
      {children}
      {manualAdjustment}
    </Stepper>
  </StyledExpansionPanelDetails>
);

export default TransactionHistoryBase;
